import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SavedDataInfo } from '../../../../models/form/saved-data-info';
import { ItemTypesService } from '../../../../services/api/general-settings/item-types.service';
import { ItemTypesFormComponent } from '../components/item-types-form/item-types-form.component';

@Component({
  selector: 'app-item-types-edit-page',
  imports: [ItemTypesFormComponent],
  templateUrl: './item-types-edit-page.component.html',
  styleUrl: './item-types-edit-page.component.scss'
})
export class ItemTypesEditPageComponent {
  itemTypeId!: number
  itemType?: any;

  constructor(
    private route: ActivatedRoute,
    private itemTypesService: ItemTypesService,
  ) {
  }

  ngOnInit(): void {
    this.itemTypeId = Number(this.route.snapshot.paramMap.get('itemTypeId'));
    if (this.itemTypeId) {
      this.loadData(this.itemTypeId);
    }
  }

  loadData(itemTypeId: any) {
    this.itemTypesService.detail(itemTypeId).subscribe((response: any) => {
      this.itemType = response.data?.itemType;
    });

  }
}
